import { create } from "zustand";
import { VideoPlatformMeeting, VideoPlatformResource } from "../api/video_platform";
import { buildMeetingQueryParams } from "../components/video_platform/utils";

interface VideoPlatformState {
  meetings: VideoPlatformMeeting[];
  loading: boolean;
  error: string | null;
  statusFilter: string;
  loadMeetings: (status?: string) => Promise<void>;
}

export const useVideoPlatformStore = create<VideoPlatformState>((set, get) => ({
  meetings: [],
  loading: false,
  error: null,
  statusFilter: "ALL",

  loadMeetings: async (status) => {
    // Reuse the current filter on a plain refresh; switch + persist on change.
    const statusFilter = status ?? get().statusFilter;
    set({ loading: true, error: null, statusFilter });
    try {
      const response = await VideoPlatformResource.getMeetings(
        buildMeetingQueryParams(statusFilter)
      );
      set({ meetings: response.data, loading: false });
    } catch (err) {
      const error = err instanceof Error ? err.message : "Failed to load meetings";
      set({ error, loading: false });
    }
  },
}));
